import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { getStoreCardFieldRows } from "./storeCardFields";

export default function StoreCardBody({
  asset,
  orderedFieldKeys,
  displayClientProject,
  displayWarehouse,
  reservationsEnabled,
  onOpenDetails,
}) {
  const rows = getStoreCardFieldRows({
    asset,
    orderedFieldKeys,
    displayClientProject,
    displayWarehouse,
    reservationsEnabled,
  });

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {rows.map(row => (
        <Typography
          key={row.fieldKey}
          color={row.fieldKey === "reserved_quantity" ? "textSecondary" : "textPrimary"}
          fontWeight={row.fieldKey === "available_quantity" ? 500 : 400}
          sx={{ cursor: onOpenDetails ? "pointer" : "default" }}
          onClick={onOpenDetails}
        >
          {row.value}
        </Typography>
      ))}
    </Box>
  );
}
